var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content"},[_c('div',{staticClass:"title"},[_c('div',{staticClass:"test"},[_vm._v(" "+_vm._s(_vm.title)+" ")])]),_c('img',{attrs:{"src":_vm.url,"alt":""},on:{"click":_vm.showIgm}}),_vm._m(0),_c('div',{staticClass:"remark",domProps:{"innerHTML":_vm._s(_vm.remark ? _vm.remark : '暂无')}})])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"abstract"},[_c('span',[_vm._v("简介")])])
}]

export { render, staticRenderFns }